import { formatInTimeZone, toDate } from 'date-fns-tz';
import { AbstractJsonConverter } from 'json-ts-mapper';

export class DateTimeConverter extends AbstractJsonConverter<string, Date> {
  serialize (obj: Date): string {
    // eslint-disable-next-line no-restricted-syntax
    return obj.toISOString();
  }

  deserialize (obj: string): Date {
    return toDate(obj);
  }
}
export class DateConverter extends AbstractJsonConverter<string, Date> {
  serialize (obj: Date): string {
    return formatInTimeZone(obj, 'Europe/Paris', 'yyyy-MM-dd');
  }

  deserialize (obj: string): Date {
    return toDate(obj, { timeZone: 'Europe/Paris' });
  }
}
